import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeViewerOption } from 'src/types/shared/User';

export const populateChallengeGroupViewersRequest = createAction(
    'populateChallengeGroupViewersRequest',
);
export const populateChallengeGroupViewersSuccess = createAction<ChallengeViewerOptionPayload>(
    'populateChallengeGroupViewersSuccess',
);
export const populateChallengeGroupViewersFailure = createAction(
    'populateChallengeGroupViewersFailure',
);

export const populateChallengeGroupViewers = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(populateChallengeGroupViewersRequest());
    try {
        const { data } = await api.get<ChallengeViewerOptionPayload>(
            `admin/challengegroups/${challengeID}/edit-challenge-admins`,
        );
        dispatch(populateChallengeGroupViewersSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, populateChallengeGroupViewersFailure, e);
    }
};

export interface ChallengeViewerOptionPayload {
    users: ChallengeViewerOption[];
}
